import Select from './Select';

export default Select;
export type { ISelectProps } from './Select';
export { default as SelectMenu } from './Select.Menu';
